import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import pluralize from 'rebook/apps/utils/text/pluralize';
import SubscriptionLabel from 'rebook/apps/base/components/SubscriptionLabel';

import styles from './style.scss';


const SubscriptionsInfo = ({ actualSubscriptionsList, outdatedSubscriptionsList }) => (
  <div className={classNames(styles.subscription, 'jest-header-nav-subscriptions')}>
    {actualSubscriptionsList.length > 0 && (
      <React.Fragment>
        <div className={styles.title}>
          {pluralize(
            actualSubscriptionsList.length,
            'Активная подписка',
            'Активные подписки',
            'Активных подписок'
          )}
        </div>
        <ul>
          {actualSubscriptionsList.map((item) => (
            <li
              className={styles.subscriptionItem}
              key={`${item.type}-${item.dateTill}`} >
              <SubscriptionLabel
                type={item.type}
                dateTillString={item.dateTill} />
            </li>
          ))}
        </ul>
      </React.Fragment>
    )}

    {outdatedSubscriptionsList.length > 0 && (
      <React.Fragment>
        <div className={classNames(
          styles.title, { [styles.titleLast]: actualSubscriptionsList.length > 0 },
        )}>
          {pluralize(
            outdatedSubscriptionsList.length,
            'Неактивная подписка',
            'Неактивные подписки',
            'Неактивных подписок'
          )}
        </div>
        <ul>
          {outdatedSubscriptionsList.map((item) => (
            <li
              className={styles.subscriptionItem}
              key={`${item.type}-${item.dateTill}`} >
              <SubscriptionLabel
                type={item.type}
                dateTillString={item.dateTill} />
            </li>
          ))}
        </ul>
      </React.Fragment>
    )}
  </div>
);

SubscriptionsInfo.propTypes = {
  actualSubscriptionsList: PropTypes.array,
  outdatedSubscriptionsList: PropTypes.array,
};

SubscriptionsInfo.defaultProps = {
  actualSubscriptionsList: [],
  outdatedSubscriptionsList: [],
};

export default SubscriptionsInfo;
